import { Input, message } from 'antd';

import { Comment, Rate, Image, Button } from 'antd';
import { saveProblemReplyRecord } from '../api.js';
import './detailRecord.less';
import Upload from '../../../compoment/upload.js';
import React, { useState, useEffect, useRef } from 'react';
const { TextArea } = Input;
const DetailRecord = (props, ref) => {
	useEffect(() => {}, []);
	const [evaluateForm, setEvaluateForm] = useState({
		id: null,
		isHandle: 0,
		problemFeedBackId: props.bizId,
		replyContent: '',
		saveProblemFeedBackAttachmentDTOS: []
	});

	// 确认回复
	function okReply() {
		if (!evaluateForm.replyContent) {
			message.error('请输入回复');
			return;
		}
		let urlData = [];
		if (uploadRecords.current.data) {
			urlData = (uploadRecords.current.data || []).map((item) => {
				return {
					attachmentName: item.data.orginalFileName,
					attachmentUrl: item.data.uploadFileUrl,
					fileSize: item.data.fileSize,
					id: item.data.id,
					uploadDate: item.data.uploadTime
				};
			});
		}
		saveProblemReplyRecord({
			...evaluateForm,
			saveProblemFeedBackAttachmentDTOS: urlData,
			replyCode: '1526005',
			replyName: '提问端',
			id: null
		}).then((res) => {
			if (res.success) {
				props.setDetailOpen(false);
				message.success('处理成功');
				setEvaluateForm({
					id: null,
					isHandle: 0,
					problemFeedBackId: props.bizId,
					replyContent: '',
					saveProblemFeedBackAttachmentDTOS: []
				});
				uploadRecords.current.wipeData();
			}
		});
	}
	// 注册成ref
	const uploadRecords = useRef();
	return (
		<div>
			<div className="titleText">反馈信息</div>
			<div className="formShadow">
				<div>
					{props.newDetailData.map((item, index) => {
						// 设置有id才会显示出区块
						return item.id ? (
							<div className={item.replyCode === '1526010' ? 'leftBody' : 'rightBody '}>
								<Comment
									author={<span>{item.operateUserName}</span>}
									avatar={<span className="avatarText">{item.typeText}</span>}
									datetime={<span>{item.judgeTime || item.feedBackTime}</span>}
									content={
										<div>
											<div>
												{(item.typeText === '评价' && item.judgeContent) ||
													(item.typeText === '回复' && item.replyContent) ||
													item.replyContent ||
													''}
											</div>
											<div>
												{item.judgeLevelName ? (
													<div>
														服务满意度：
														<Rate disabled value={item.judgeLevelName} />
													</div>
												) : null}
												<Image.PreviewGroup alt="预览">
													{(item.problemFeedBackAttachmentVOS || []).map((i, index) => {
														return <Image width={80} height={80} src={i || ''} />;
													})}
												</Image.PreviewGroup>
											</div>
										</div>
									}>
									{/* <template slot="author">{} </template>
									<template slot="datetime">{item.judgeTime || item.feedBackTime}</template>
									<template slot="actions">
										<div v-if="item.typeText === '评价'">
											服务满意度：
											<a-rate disabled value="item.judgeLevelName" />
										</div>
									</template>
									<template slot="content">
										{(item.typeText === '评价' && item.judgeContent) ||
											(item.typeText === '回复' && item.replyContent) ||
											(item.typeText === '建议反馈' && item.replyContent) ||
											''}
									</template> */}
								</Comment>
							</div>
						) : (
							''
						);
					})}
				</div>
			</div>
			{props.subForm.statusCode !== '1481015' && props.subForm.isHandle === 0 ? (
				<div>
					<div className="titleText">回复信息</div>
					<div className="formShadow">
						<div className="feedbackFormItem">
							{' '}
							<span className="redStar">*</span>问题描述
						</div>
						<TextArea
							rows={4}
							placeholder="请输入问题反馈"
							maxLength={1000}
							showCount
							value={evaluateForm.replyContent}
							onChange={(e) => {
								setEvaluateForm({
									...evaluateForm,
									replyContent: e.target.value
								});
							}}
						/>
						<div className="feedbackFormItem martop10">上传图片</div>

						<div>
							<Upload ref={uploadRecords}></Upload>
						</div>

						<div>
							<Button type="primary" onClick={okReply}>
								确认
							</Button>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};
export default DetailRecord;
